import { createSlice } from "@reduxjs/toolkit";

export const shippingFormSlice = createSlice({
    name: "shippingForm",
    initialState: {
        contactInformation: {
            email: "",
            phone: ""
        },
        recipientInformation: {
            firstName: "",
            lastName: "",
            company: ""
        },
        shippingInformation: {
            addressLine1: "",
            addressLine2: "",
            city: "",
            state: "",
            zip: "",
            country: ""
        },
        shippingOptions: [
            { 
                optionName: 'USPS Ground Advantage',
                basePrice: 10,
                increment: 2
            }, 
            {
                optionName: 'USPS Priority',
                basePrice: 15,
                increment: 5
            }
        ],
        shippingMethod: {}
    },
    reducers: {
        setContactEmail: (state, action) => {
            return {
                ...state,
                contactInformation: {
                    ...state.contactInformation,
                    email: action.payload
                }
            }
        },
        setContactPhone: (state, action) => {
            return {
                ...state,
                contactInformation: {
                    ...state.contactInformation,
                    phone: action.payload
                }
            }
        },
        setRecipientFirstName: (state, action) => {
            return {
                ...state,
                recipientInformation: {
                    ...state.recipientInformation,
                    firstName: action.payload
                }
            }
        },
        setRecipientLastName: (state, action) => {
            return {
                ...state,
                recipientInformation: {
                    ...state.recipientInformation,
                    lastName: action.payload
                }
            }
        },
        setRecipientCompany: (state, action) => {
            return {
                ...state,
                recipientInformation: {
                    ...state.recipientInformation,
                    company: action.payload
                }
            }
        },
        setShippingAddressLine1: (state, action) => {
            return {
                ...state,
                shippingInformation: {
                    ...state.shippingInformation,
                    addressLine1: action.payload
                }
            }
        },
        setShippingAddressLine2: (state, action) => {
            return {
                ...state,
                shippingInformation: {
                    ...state.shippingInformation,
                    addressLine2: action.payload
                }
            }
        },
        setShippingCity: (state, action) => {
            return {
                ...state,
                shippingInformation: {
                    ...state.shippingInformation,
                    city: action.payload
                }
            }
        },
        setShippingState: (state, action) => {
            return {
                ...state,
                shippingInformation: {
                    ...state.shippingInformation,
                    state: action.payload
                }
            }
        },
        setShippingZip: (state, action) => {
            return {
                ...state,
                shippingInformation: {
                    ...state.shippingInformation,
                    zip: action.payload
                }
            }
        },
        setShippingCountry: (state, action) => {
            return {
                ...state,
                shippingInformation: {
                    ...state.shippingInformation,
                    country: action.payload
                }
            }
        },
        setShippingOptions: (state, action) => {
            return {
                ...state,
                shippingOptions: action.payload
            }
        },
        setShippingMethod: (state, action) => {
            return {
                ...state,
                shippingMethod: action.payload
            }
        }
    }
})

export const selectContactInformation = (state) => state.shippingForm.contactInformation;
export const selectRecipientInformation = (state) => state.shippingForm.recipientInformation;
export const selectShippingInformation = (state) => state.shippingForm.shippingInformation;
export const selectShippingOptions = (state) => state.shippingForm.shippingOptions;
export const selectShippingMethod = (state) => state.shippingForm.shippingMethod;

export const {
    setContactEmail,
    setContactPhone,
    setRecipientFirstName,
    setRecipientLastName,
    setRecipientCompany,
    setShippingAddressLine1,
    setShippingAddressLine2,
    setShippingCity,
    setShippingState,
    setShippingZip,
    setShippingCountry,
    setShippingOptions,
    setShippingMethod
} = shippingFormSlice.actions;

export default shippingFormSlice.reducer;